import {
	IActor,
	IBaseApiModel,
	IBlogCampaignApprovalRequest,
	ICampaignApprovalRequest,
	ITemplateReference,
	IUserReference,
} from '.';

export enum BlogStatus {
	Queued = 'Queued',
	Pending = 'Pending',
	Completed = 'Completed',
	Cancelled = 'Cancelled',
	Failed = 'Failed',
	Draft = 'Draft',
	Rejected = 'Rejected',
}

export interface IBlogApprovalRequest {
	blog: ICampaignApprovalRequest;
}

export interface IBlogReportView extends IBaseApiModel {
	/** Discriminator the content calendar event renderer keys off of; stamped client-side after fetch. */
	_type?: 'BlogReportView';
	actor?: IActor;
	author?: IUserReference;
	approvalRequests: IBlogCampaignApprovalRequest[];
	cancelledDate?: string;
	completedDate?: string;
	// Arrives from the API's base resource model, which `BlogReportView` does not redeclare.
	creationDate?: string;
	creator?: IUserReference;
	scheduledSendDate: string;
	status: BlogStatus;
	title: string;
	templateReference?: ITemplateReference;
}
